import { useQuery } from '@apollo/client';

import { TeamMemberDocument } from './useTeamMember.gql';

export const useTeamMember = (companyProfileId = '', companyUserId = '') => {
  const { data, ...hook } = useQuery(TeamMemberDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !companyProfileId || !companyUserId,
    variables: { companyProfileId, companyUserId },
  });

  const teamMember = data?.viewer.company.teamMember ?? null;

  return { ...hook, teamMember };
};
